import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import NewLeaderForImpactDetails from "./components/NewLeaderForImpactDetails";

export default function NewLeaderForImpact() {
  return (
    <Layout>
      <NewsHeader>NAB Trust: New Leaders for Impact Investment</NewsHeader>
      <NewLeaderForImpactDetails />
    </Layout>
  );
}
